"use client";

import { useEffect } from "react";
import { SIZE_SELECTOR_ERROR_NO_SIZE_SELECTED } from "@/constants/constants.ts";
import { useShowStoreStockButton } from "@/hooks/useShowStoreStockButton/useShowStoreStockButton.tsx";

declare global {
  interface Window {
    isSizeSelected: () => boolean;
  }
}

export type Props = {
  displayCode: string;
  isFutureRelease: boolean;
  isPreOrderable: boolean;
  skuId: string;
  stockApiBaseUrl: string;
  stockApiKey: string;
  storeStockApiKey: string;
  storeStockModalApiUrl: string;
  storeStockScriptUrl: string;
  title: string;
  usePrimaryButton: boolean;
  hideIfStoreStockUnavailable?: boolean;
  isVariantSelected?: boolean;
};

export const StoreStock = ({
  title,
  displayCode,
  skuId,
  isFutureRelease,
  isPreOrderable,
  usePrimaryButton,
  storeStockScriptUrl,
  stockApiBaseUrl,
  stockApiKey,
  storeStockApiKey,
  storeStockModalApiUrl,
  isVariantSelected = false,
  hideIfStoreStockUnavailable = true,
}: Props) => {
  const showStoreStockButton = useShowStoreStockButton({
    storeStockApiKey,
    storeStockModalApiUrl,
    stockApiBaseUrl,
    stockApiKey,
    skuId,
    displayCode,
    isFutureRelease,
    isPreOrderable,
    hideIfStoreStockUnavailable,
  });

  useEffect(() => {
    window.isSizeSelected = () => {
      if (!isVariantSelected) {
        window.dispatchEvent(
          new CustomEvent(SIZE_SELECTOR_ERROR_NO_SIZE_SELECTED),
        );
        return false;
      } else {
        return true;
      }
    };
  }, [isVariantSelected]);

  useEffect(() => {
    let jlStoreStockEl: Element;
    let jlStoreStockScript: Element;

    setTimeout(() => {
      jlStoreStockEl = document.createElement("jl-store-stock");
      jlStoreStockEl.setAttribute("data-testid", "store-stock");
      jlStoreStockEl.setAttribute("productCode", displayCode);
      jlStoreStockEl.setAttribute("productName", title);
      jlStoreStockEl.setAttribute("skuId", skuId);
      jlStoreStockEl.setAttribute("isPrimaryButton", String(usePrimaryButton));
      document.body.appendChild(jlStoreStockEl);

      jlStoreStockScript = document.createElement("script");
      jlStoreStockScript.setAttribute("type", "text/javascript");
      jlStoreStockScript.setAttribute("src", storeStockScriptUrl);

      document.body.appendChild(jlStoreStockScript);
    });

    return () => {
      if (document.body.contains(jlStoreStockEl)) {
        document.body.removeChild(jlStoreStockEl);
      }
      if (document.body.contains(jlStoreStockScript)) {
        document.body.removeChild(jlStoreStockScript);
      }
    };
  }, [isVariantSelected]);

  if (showStoreStockButton === "hidden") return null;

  return (
    <div
      id="product:tools:store-stock"
      data-testid="product:tools:store-stock"
      aria-busy={showStoreStockButton === "isLoading"}
    >
      <div
        id="store-stock-button-wrapper"
        data-testid="product:tools:store-stock:button"
      />
    </div>
  );
};
